<div class="info-text-fixed align-center" *ngIf="showSystemMessage">
  {{systemMessage}}
</div>

